export default __webpack_public_path__ + "static/media/HappyBirthday_06.7c4d91bc.png";